<template>
  <div class="app-container" style="width:800px;">
    <el-form :model="data" :rules="rules" ref="form" label-width="95px">
      短信平台接入信息
      <el-row class="row-border">
        <el-col :span="24">
          <el-form-item label="短信ID" prop="MessageAppId">
            <el-input v-model="data.MessageAppId" placeholder="请输入短信ID"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="短信Key" prop="MessageAppKey">
            <el-input v-model="data.MessageAppKey" placeholder="请输入短信Key"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="短信签名" prop="MessageSignature">
            <el-input v-model="data.MessageSignature" placeholder="请输入短信签名"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      物流平台接入信息
      <el-row class="row-border" >
        <el-col :span="24">
          <el-form-item label="用户ID" prop="LogisticsUserId">
            <el-input v-model="data.LogisticsUserId" placeholder="请输入用户ID"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="APIKey" prop="LogisticsApiKey">
            <el-input v-model="data.LogisticsApiKey" placeholder="请输入APIKey"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="回调地址" prop="LogisticsTokenUrl">
            <el-input v-model="data.LogisticsTokenUrl" placeholder="请输入回调地址"></el-input>
          </el-form-item>
        </el-col>
               
      </el-row>
      地图平台接入信息
      <el-row class="row-border">
        <el-col :span="24">
          <el-form-item label="地图key" prop="MapKey">
            <el-input v-model="data.MapKey" placeholder="请输入地图key"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="地图密钥" prop="MapSecurityKey">
            <el-input v-model="data.MapSecurityKey" placeholder="请输入地图密钥"></el-input>
          </el-form-item>
        </el-col>
                      
      </el-row>
      <el-button v-if="canEdit" type="primary" @click="onSubmit" size="small" style="margin: 10px 10px 0 0;float:right;">保 存</el-button>
    </el-form>
  </div>
  
</template>
<script>
import singlePicUpload from "@/components/common/photo/singleUpload";

export default {
  name: "other",
  components: {
    singlePicUpload,
  },
  data() {
    return {
      data: {
        RecordId: 0,
        MessageAppId: "",
        MessageAppKey: "",
        MessageSignature: "",
        LogisticsUserId: "",
        LogisticsApiKey: "",
        LogisticsTokenUrl: "",
        MapKey:"",
        MapSecurityKey: "",
        
      },
      dialogVisible: false,
      isLoading: false,
      isMB: this.$store.state.isMB,
      api: require("@/api/access/other").default,
      canEdit: false,
      rules: {
        MessageAppId: [{ required: true, message: "短信ID不能为空" }],
        MessageAppKey: [{ required: true, message: "短信key不能为空" }],
        MessageSignature: [{ required: true, message: "短信签名不能为空" }],
        LogisticsUserId: [{ required: true, message: "物流用户ID不能为空" }],
        LogisticsApiKey: [{ required: true, message: "物流APIkey不能为空" }],
        LogisticsTokenUrl: [{ required: true, message: "物流回调地址不能为空" }],
        MapKey: [{ required: true, message: "地图key不能为空" }],
        MapSecurityKey: [{ required: true, message: "地图密钥不能为空" }],
        
      },
      uploadUrl: "/api/Common/UploadPicture",
    };
  },
  mounted() {
    this.canEdit = this.$permission.canEdit();
    this.api.info(1).then((res) => {
      if (res.Code == 0) {
        this.data = res.Data;
      } else {
        this.$message.error(res.Msg);
      }
    });
  },
  methods: {
    checkInt(name) {
      if(!(this.data[name] >= 0)) {
        this.data[name] = 0;
      } else if(this.data[name] %1 != 0) {
        this.data[name] = Math.floor(this.data[name]);
      }
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.isLoading = true;
          this.api.save(this.data).then((res) => {
            this.isLoading = false;
            if (res.Code == 0) {
              this.$message({
                message: res.Msg,
                type: "success",
                duration: 3000,
              });
            } else {
              this.$message.error(res.Msg);
            }
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>
